import React from "react";

const Contact = () => {
  return (
    <div
      style={{
        padding: "20px",
        borderRadius: "8px",
        maxHeight: "70vh",
        overflowY: "auto",
      }}
    >
      <h2 style={{ fontSize: "24px", color: "#007bff", marginBottom: "20px" }}>
        Contact
      </h2>

      <h3 style={{ fontSize: "18px", color: "#007bff", marginTop: "10px" }}>
        Founder & CEO:
      </h3>
      <p>
        Oleg Grigor’evic Shitsel –{" "}
        <a
          href="mailto:olegs@bambkuss.com"
          style={{ color: "#007bff", textDecoration: "none" }}
        >
          olegs@bambkuss.com
        </a>
      </p>

      <h3 style={{ fontSize: "18px", color: "#007bff", marginTop: "15px" }}>
        1. Co-Founder:
      </h3>
      <p>
        Maksim Khazanov –{" "}
        <a
          href="mailto:max@bambkuss.com"
          style={{ color: "#007bff", textDecoration: "none" }}
        >
          max@bambkuss.com
        </a>
      </p>

      <h3 style={{ fontSize: "18px", color: "#007bff", marginTop: "15px" }}>
        2. Co-Founder:
      </h3>
      <p>
        Cepi Saeful Bednarz –{" "}
        <a
          href="mailto:cepi@bambkuss.com"
          style={{ color: "#007bff", textDecoration: "none" }}
        >
          cepi@bambkuss.com
        </a>
      </p>

      <p style={{ marginTop: "20px" }}>
        If you have any questions or concerns, please do not hesitate to
        contact us! We will endeavor to respond to your email as soon as
        possible.
      </p>
    </div>
  );
};

export default Contact;
